import { Title } from '@mantine/core';

import classes from './title.module.css';

const defaultTitleProps = Title.extend({
  classNames: {
    root: classes.root,
  },
});
export { Title, defaultTitleProps };
